import { Subject } from "observable-fns";
import { singleton } from "tsyringe";
import { ContextBase } from "views/ContextBase";


@singleton()
export class Context extends ContextBase {
    
}